import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.25 9.432 2.818 7l-.829.822 3.261 3.261 7-7-.822-.822L5.25 9.432Z",
    fill: "#fff"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h14v14H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };